import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

const NavbarPrimary = () => {
  return (
  <>
    <Navbar expand="lg" className="bg-body-tertiary desk-hide">
      
      <Container>
        
          <Row>
          
        <Col xs={4} lg={5} md={4} sm={4}>   <Navbar.Brand href="#home"> <img src="/assets/images/logo/logo.png" className='mainlogo' alt="planetronix logo" /> </Navbar.Brand>   </Col>
        <Col xs={8} lg={7} md={8} sm={8}>  
        <Navbar.Toggle aria-controls="basic-navbar-nav" className='mobile-menu' />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
<NavDropdown title="About us" id="basic-nav-dropdown">
              <NavDropdown.Item href="/our-vision"> Our Vision</NavDropdown.Item>
              <NavDropdown.Item href="/our-mission"> Our Mission </NavDropdown.Item>
            </NavDropdown>


<NavDropdown title="Products" id="basic-nav-dropdown">
              <NavDropdown.Item href="/aviation-products">  Aviation Products </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.1">  Rugged Displays </NavDropdown.Item>
               <NavDropdown.Item href="#action/3.1">  Rugged KVM Displays  </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.1">   Rugged Panel PCs </NavDropdown.Item>
                 <NavDropdown.Item href="#action/3.1">  Rugged Workstations </NavDropdown.Item>
                  <NavDropdown.Item href="#action/3.1">  Rugged Servers </NavDropdown.Item>
                   <NavDropdown.Item href="#action/3.1">  Rugged Ethernet Switches </NavDropdown.Item>

            </NavDropdown>


<NavDropdown title="Industries" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1"> Military & Defence </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.1"> Aerospace </NavDropdown.Item>
               <NavDropdown.Item href="#action/3.1"> Govenment & PSU </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#link"> Contact us </Nav.Link>
          </Nav>
        </Navbar.Collapse>  </Col>
          </Row>
       
      </Container>
    </Navbar>
  
  
  </>
  )
}

export default NavbarPrimary